jQuery($ => {
	const builderFormClass = '.builder-form';
    window.dataLayer = window.dataLayer || [];

    //On load do we have a form confirmation? If so trigger dataLayer Event
    $(builderFormClass + ' .alert-success').each(function() {
        var formID = $(this).closest(builderFormClass).attr('id');

        window.dataLayer.push({
            event: 'formSubmission',
            eventCategory: 'Form Submission',
            eventAction: 'Submit',
            eventLabel: window.location.href,
            formID: formID
        });
    });
});
